import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

export const guideRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'guide-themes-list',
    component: () => import('pages/interactive-guide/InteractiveGuide.vue'),
  },
  {
    path: '/guide-gateway',
    alias: $gettext('/rozcestnik-pruvodce/'),
    name: 'guide-gateway',
    component: () =>
      import('pages/interactive-guide/InteractiveGuideGateway.vue'),
  },
];
